import React from 'react';

export default function Copyright() {

    return (
        <footer className="bg-black w-100" style={{ position: "absolute", bottom: 0, textAlign: "center" }}>
            <p className="text-white">Caesar Cipher. 2022. All Rights Reserved.</p>
        </footer>
    )
}